import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import {
    withRouter
} from 'react-router-dom';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import * as actions from '../../actions/login.Action';
import { Constants } from '../../config/appConstants';
import MaterialListComponent from './materialList.component';
import { MessageBox } from '../sharedComponent/messageBox';

class MaterialListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditMaterialList: false,
            isSaveButtonDisabled: false,
            isShowDeleteConfiram: false,
            isOpenModel: false,
            materialListDataList: [],
            materialListNameSearch: "",
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedIdForDelete: "",
            selectedValue: {}
        };
    }

    componentDidMount() {
        this.getMaterialList();
    }

    getMaterialList() {
        let { materialListNameSearch, pagination } = this.state;
        let searchArray = [];
        if (materialListNameSearch) {
            let searchObj = {
                FieldName: Constants.MATERIAL_LIST_SEARCH,
                Value: materialListNameSearch
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.MATE_C}${ApiUrls.Routes.GT_MATE_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    this.setState({
                        materialListDataList: responseData.data,
                        pagination
                    });
                }
                else {
                    this.setState({
                        materialListDataList: []
                    });
                }
            }
        });
    }

    getMaterialListDetails(materialListId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.MATE_C}${ApiUrls.Routes.GT_MATE_M}?materialId=${materialListId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData && responseData.success) {
                    selectedValue.materialListName = responseData.data.displayText;
                    selectedValue.materialListId = responseData.data.id;
                    this.setState({
                        selectedValue, isEditMaterialList: true
                    });
            }
        });
    }

    handleMaterialListChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.materialListName = value;
        this.setState({ selectedValue });
    }

    onCancelDelete = () => {
        this.setState({ isShowDeleteConfiram: false, selectedValue: {} })
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditMaterialList: false, selectedValue: {} }, () => this.getMaterialList());
    }

    onConfirmDelete = () => {
        let { selectedIdForDelete } = this.state;
        let url = `${ApiUrls.Routes.MATE_C}${ApiUrls.Routes.DLT_MATE_M}?materialId=${selectedIdForDelete}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                this.setState({ isShowDeleteConfiram: false, selectedValue: {} }, () => {
                    var apage = Math.ceil(this.state.materialListDataList.length - 1 === 0 && this.state.pagination.totalCount !== 1 ? (this.state.pagination.totalCount - 1) : this.state.pagination.totalCount);
                    this.onPageChange(null, { activePage: this.state.pagination.activePage > apage ? apage : this.state.pagination.activePage });
                });
            }
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
        });
    }

    onDeleteMaterialList = (materialListDetails) => {
        this.setState({ isShowDeleteConfiram: true, selectedIdForDelete: materialListDetails.materialListId });
    }

    onMaterialListSearch = event => {
        this.setState({ materialListNameSearch: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getMaterialList();
        });
    }

    onOpenModel = materialListDetails => {
        if (materialListDetails.materialListId) {
            this.getMaterialListDetails(materialListDetails.materialListId);
        }
        this.setState({
            isOpenModel: true,
            selectedValue: {},
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getMaterialList();
        });
    }

    onSaveMaterialList(materialListId = null) {
        let { selectedValue } = this.state;
        this.setState({ isSaveButtonDisabled: true });
        if (!selectedValue.materialListName || !selectedValue.materialListName.trim()) {
            MessageBox(Constants.PLEASE_ENTER_MATERIAL_NAME, Constants.ERROR);
            this.setState({ isSaveButtonDisabled: false });
            return;
        }
     
        let requestData = {
            Id: selectedValue.materialListId,
            DisplayText: selectedValue.materialListName.trim(),
        }

        let url = `${ApiUrls.Routes.MATE_C}${ApiUrls.Routes.SV_MATE_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                this.setState({ isSaveButtonDisabled: false });
            }
            if (responseData.success) {
                this.onCloseModel();
            }
        });
    }



    render() {
        const { 
            isEditMaterialList,
            isOpenModel,
            isSaveButtonDisabled,
            isShowDeleteConfiram,
            materialListDataList,
            pagination,
            selectedValue,
        } = this.state;
        return (
            <Fragment>
                <MaterialListComponent
                    {...{
                        materialList: {
                            isEditMaterialList,
                            isOpenModel,
                            isSaveButtonDisabled,
                            isShowDeleteConfiram,
                            materialListDataList,
                            pagination,
                            selectedValue,
                        }
                    }}
                    handleMaterialListChange={this.handleMaterialListChange.bind(this)}
                    onCancelDelete={this.onCancelDelete.bind(this)}
                    onConfirmDelete={this.onConfirmDelete.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onDeleteMaterialList={this.onDeleteMaterialList.bind(this)}
                    onMaterialListSearch={this.onMaterialListSearch.bind(this)}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    onSaveMaterialList={this.onSaveMaterialList.bind(this)}
                    user={this.props.user}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MaterialListPage));
MaterialListPage.displayName = 'MaterialListPage';